import React, { useState, useEffect, useRef } from "react";
import { FaBars } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import profile_Img from "../../../../Assets/Images/profile_Img.png";
import LogoutModal from "../../../../Components/Modals/LogoutModal";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { logOutUser } from "../../../../Redux/slices/AuthSlice";
import { postApiCaller } from "../../../../Libs/apiCaller";
import { toast } from "react-toastify";

export default function Header() {
  const { userInfo } = useSelector((state) => state.authUser);
  const { fcmToken } = useSelector((state) => state.authUser);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const menuRef = useRef(null); // Reference for the menu
  const profileRef = useRef(null); // Reference for the profile avatar
  const [openLogoutConfirmModal, setOpenLogoutConfirmModal] = useState(false);
  const [, , removeCookie] = useCookies(["accessToken"]);
  const navigate = useNavigate();
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const dispatch = useDispatch();

  // Close the menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const logoutConfirm = async () => {
    setIsLoading(true);
    const endPoint = "auth/logout";
    const payload = {
      fcmToken: fcmToken,
    };
    const response = await postApiCaller(endPoint, payload);
    if (response?.status === 200) {
      localStorage.removeItem("userId");
      dispatch(logOutUser());
      removeCookie("accessToken", {
        path: "/",
        secure: true,
        httpOnly: false,
        sameSite: "Strict",
      }); // Remove authentication token
      toast.success("Logged out successfully");
      navigate("/sign-in");
    }
    setIsLoading(false);
  };

  return (
    <>
      <section className="min-h-[80px] bg-white flex justify-between items-center px-8 p-4 ">
        <div className="flex items-center">{/* Logo or other content */}</div>

        {/* Avatar, Name, and Admin */}
        <div className="flex items-center">
          <div className="relative" ref={profileRef}>
            <img
              src={
                userInfo?.avtarImage ||
                userInfo?.userImage ||
                userInfo?.userMedia ||
                profile_Img
              } // Placeholder for avatar
              alt="Avatar"
              className="min-w-[48px] min-h-[48px] max-w-[48px] max-h-[48px] rounded-full cursor-pointer"
              onClick={toggleMenu}
            />
            {/* Profile Menu */}
            {menuOpen && (
              <div
                ref={menuRef}
                className="absolute right-0 left-[2px] mt-2 bg-white border rounded shadow-lg p-2 w-26"
              >
                {/* <div className="text-sm font-medium text-gray-700 cursor-pointer py-2 px-4 hover:bg-gray-100" onClick={() => alert('Profile Clicked')}>
                Profile
              </div> */}
                <div
                  className="text-sm font-medium text-gray-700 cursor-pointer py-2 px-4 hover:bg-gray-100"
                  onClick={() => {
                    setMenuOpen(false); // Close the menu
                    setOpenLogoutConfirmModal(true); // Open the logout modal
                  }}
                >
                  Logout
                </div>
              </div>
            )}
          </div>
          <div className="ml-2">
            <div
              className="text-sm font-medium text-[#525252] hover:text-[var(--primary-color)] cursor-pointer"
              onClick={toggleMenu}
            >
              {userInfo?.name}
            </div>
            <div
              className="text-xs pt-1.5 font-normal text-[var(--primary-color)] hover:text-black cursor-pointer "
              onClick={toggleMenu}
            >
              Admin
            </div>
          </div>
        </div>
      </section>
      <LogoutModal
        isOpen={openLogoutConfirmModal}
        onClose={() => setOpenLogoutConfirmModal(false)}
        onLogout={() => logoutConfirm()}
        isLoading={isLoading}
      />
    </>
  );
}
